const anos: any[] = [];
const todayYear = new Date().getFullYear() - 18;

for (let i = 0; i < 100; i++) {
    anos.push(todayYear - i);
}

export default anos;
